import React from "react";
// import React, {useState, useEffect, useRef} from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import {authAxios} from "../utils";
import { Row, Col, Card } from "antd";
import {
  UsergroupAddOutlined,
  GoldFilled,
  DatabaseFilled,
  CarryOutFilled,
  TeamOutlined,
  SolutionOutlined,
  BankOutlined,
} from "@ant-design/icons";

class Settings extends React.Component {
  state = {
    loading: false,
  };

  componentDidMount() {}

  render() {
    return (
      <>
        <Row
          //   style={{ justifyContent: "center", textAlign: "center" }}
          gutter={[8, 8]}
          justify="start"
          align="middle"
        >
          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/users"}>
                <span style={{ fontSize: 40 }}>
                  <UsergroupAddOutlined className="styleIcon_1" />
                </span>
                <h1>Người dùng</h1>
                <p>Quản lý danh sách người dùng</p>
              </Link>
            </Card>
          </Col>
          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/bophansudung"}>
                <span style={{ fontSize: 40 }}>
                  <GoldFilled className="styleIcon_1" />
                </span>
                <h1>Bộ phận sử dụng</h1>
                <p>Quản lý bộ phận sử dụng</p>
              </Link>
            </Card>
          </Col>
          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/bophanxuly"}>
                <span style={{ fontSize: 40 }}>
                  <DatabaseFilled className="styleIcon_1" />
                </span>
                <h1>Bộ phận xử lý</h1>
                <p>Quản lý danh sách bộ phận xử lý</p>
              </Link>
            </Card>
          </Col>

          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/loaiyeucau"}>
                <span style={{ fontSize: 40 }}>
                  <CarryOutFilled className="styleIcon_1" />
                </span>
                <h1>Loại yêu cầu</h1>
                <p>Quản lý danh sách loại yêu cầu</p>
              </Link>
            </Card>
          </Col>

          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/team"}>
                <span style={{ fontSize: 40 }}>
                  <TeamOutlined className="styleIcon_1" />
                </span>
                <h1>Team</h1>
                <p>Quản lý danh sách team</p>
              </Link>
            </Card>
          </Col>

          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/chucvu"}>
                <span style={{ fontSize: 40 }}>
                  <SolutionOutlined className="styleIcon_1" />
                </span>
                <h1>Chức vụ</h1>
                <p>Quản lý danh sách chức vụ</p>
              </Link>
            </Card>
          </Col>

          <Col span={6}>
            <Card style={{ textAlign: "center" }}>
              <Link to={"/settings/vanphong"}>
                <span style={{ fontSize: 40 }}>
                  <BankOutlined className="styleIcon_1" />
                </span>
                <h1>Văn phòng</h1>
                <p>Quản lý danh sách văn phòng</p>
              </Link>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // refreshCart: () => dispatch(fetchCart())
  };
};

export default withRouter(connect(null, mapDispatchToProps)(Settings));
